import { Controller } from "@hotwired/stimulus"
import ToastController from "./toast_controller"

export default class extends Controller {
  static targets = ["copyLinkButton"]

  copyShareLink(event) {
    const link = event.currentTarget.getAttribute('data-clipboard-text')
    navigator.clipboard.writeText(link).then(() => {
      // Temporarily change button appearance to indicate success
      const originalIcon = this.copyLinkButtonTarget.querySelector('i').className
      this.copyLinkButtonTarget.querySelector('i').className = 'fas fa-check'

      // Show success toast notification
      ToastController.showSuccess('Share Link Copied!')

      // Revert back after 2 seconds
      setTimeout(() => {
        this.copyLinkButtonTarget.querySelector('i').className = originalIcon
      }, 2000)
    }).catch(err => {
      console.error('Could not copy text: ', err)
      ToastController.showError('Failed to Copy Share Link!')
    })
  }

  nativeShare(event) {
    event.preventDefault();
    if (navigator.share) {
      navigator.share({
        title: document.title,
        text: "Check out this discovery on Seeniq!",
        url: window.location.href
      }).catch((error) => {
        // User cancelled or error
        if (error && error.name !== 'AbortError') {
          ToastController.showError('Failed to open share dialog!')
        }
      });
    } else {
      ToastController.showError('Native sharing is not supported on this device/browser!')
    }
  }
}
